import React, { useState, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./prevstyle.css";

import { LPAD, getURLParam, DownloadFile } from "util";

import axios from 'util/axios';
import ModalPortal from "util/component/Modal";
import { useSelector } from "react-redux";

import { table_render } from 'util';


const DATATABLE_SEPERATOR = "::DATATABLE::";

const html_render = (html) => {
    if(!html) {
        return null;
    }

    const body = document.createElement("div");

    body.innerHTML = html;

    let body2 = body.innerHTML.replaceAll(/(\[:[^\]]+:\])/g,'<a onClick=\'event.stopPropagation()\' class=\'tblref\' data-tblref=\'$1\'>$1</a>')

    return body2;
}



const Preview = (props) => {
    const { state } = useLocation();
    const [Data, SetData] = useState();
    const [List, SetList] = useState({ content: [], table: [], image: [] });
    const [Orientation, SetOrientation] = useState(false);

    const [ModalShow, SetModalShow] = useState(null);
    const userSelector = useSelector(store => store.user);
    const navigate = useNavigate();

    const getDocData = async () => {

        const params = getURLParam();
        const data = params.data;
        const decodeddata = atob(decodeURIComponent(data).toString());
        const postData = JSON.parse(decodeddata);

        if (userSelector.userId !== postData.userId) {
            navigate("/error/403", { replace: true });
            return;
        }

        const response = await axios.post(process.env.REACT_APP_API + "/pcsGenerate/retrieveGenerateTemplateForPreview", postData);


        const docData = response?.data?.data;


        SetData({ ...docData, revInfo: postData.revInfo });
    };

    useEffect(() => {

        if (props?.docData) {
            SetData(props?.docData);
        } else if (state?.docData) {
            SetData(state.docData);
        } else {
            getDocData();
        }
        window.history.pushState(null, "", window.location.href);
        const onPopState = (e) => {
            window.close();
        };
        window.onpopstate = onPopState;
    }, [props?.docData, state?.docData]);

    const RevInfoRender = useMemo(() => {
        const dataMap = Data?.sheetList?.map((tbl) => {
            const { master } = tbl;
            return { ...master };
        });

        return dataMap?.map((tblData, index) => {
            const { projectNm, mbrNo, processCd, unitNm, revision } = tblData;
            return (
                <tr key={`revisinoInfo${index}`}>
                    <td>{projectNm}</td>
                    <td>{mbrNo}</td>
                    <td>{processCd}</td>
                    <td>{unitNm}</td>
                    <td>{revision}</td>
                </tr>
            );
        });
    }, [Data]);

    const MainRender = useMemo(() => {
        const descInfo = Data?.desc[0];

        const Header = html_render(descInfo?.descHeader);
        const Common = html_render(descInfo?.descCommon);
        const Footer = html_render(descInfo?.descFooter);

        const Tables = Data?.sheetList?.map((tbl) => {
            let htmlStr = [];
            let sheetDescReplace = html_render(tbl?.master.webContent);

            if (tbl["composition"] && tbl["composition"].length > 0) {
                htmlStr.push(table_render("composition", tbl));
            }
            htmlStr.push(table_render("in", tbl));
            htmlStr.push(table_render("out", tbl));
            htmlStr.push(table_render("qc", tbl));

            return { tables: htmlStr, desc: sheetDescReplace };
        });

        return (
            <>
                <div className="pdf-page ck-content" dangerouslySetInnerHTML={{ __html: Header }}></div>
                <div className="pdf-page ck-content" dangerouslySetInnerHTML={{ __html: Common }}></div>
                {Tables?.map((tbl, i) => {
                    return (
                        <React.Fragment key={"pdfpreview" + i}>
                            {tbl.desc && <div className="pdf-page ck-content" dangerouslySetInnerHTML={{ __html: tbl.desc }}></div>}
                            {tbl.tables?.map((tblInner, i2) => {
                                if (tblInner) {
                                    return <div key={"pdfpreview" + i + "_" + i2} className="pdf-page ck-content data-tables" dangerouslySetInnerHTML={{ __html: tblInner }}></div>;
                                } else return null;
                            })}
                        </React.Fragment>
                    );
                })}
                <div className="pdf-page ck-content" dangerouslySetInnerHTML={{ __html: Footer }}></div>
            </>
        );
    }, [Data]);

    useEffect(() => {
        let tmout = null;
        if (props.docData) {
            tmout = setTimeout(() => savePDF(), 300);
        }
        if (Data) {
            document.querySelectorAll("span").forEach((e) => {
                const color = e.style.backgroundColor;
                if (color) {
                    e.style.backgroundColor = "transparent";
                    e.style.textShadow = "0px 0px 10px " + color;
                }
            });

            let cnt = 0;
            let cnt2 = 0;
            let cnt3 = 0;
            let cnt4 = 0;

            let tCnt = 0;
            let tImg = 0;
            const pdfContainer = document.getElementById("pdf-container");
            const contentList = { content: [], table: [], image: [] };
            pdfContainer.querySelectorAll("h1, h2, h3, h4, figcaption").forEach((e) => {
                if (e.tagName.toUpperCase() === "FIGCAPTION") {
                    const figure = e.closest("figure");
                    const isTable = figure.classList.contains("table");
                    const isImage = figure.classList.contains("image");
                    if (isTable) {
                        tCnt++;
                        e.innerHTML = `Table ${tCnt}. ` + e.innerHTML.toString().replaceAll(/^Table [\d.]+\. /g, "");
                        contentList.table.push({ innerHTML: e, id: `tbl${tCnt}`, tbltp: e.dataset.tblnm && e.dataset.tblnm+e.dataset.tbltp });
                        e.id = `tbl${tCnt}`;
                    } else if (isImage) {
                        tImg++;
                        e.innerHTML = `Figure ${tImg}. ` + e.innerHTML.toString().replaceAll(/^Figure [\d.]+\. /g, "");
                        contentList.image.push({ innerHTML: e, id: `img${tImg}` });
                        e.id = `img${tImg}`;
                    }
                } else {
                    let isDataTable = e.classList.contains("exclude_heading");
                    switch (e.tagName.toUpperCase()) {
                        case "H1":
                            cnt++;
                            e.innerHTML = `${cnt}. ` + e.innerHTML.replace(/^[0-9\.]+ /, '');

                            cnt2 = 0;
                            cnt3 = 0;
                            cnt4 = 0;
                            break;
                        case "H2":
                            cnt2++;
                            e.innerHTML = `${cnt}.${cnt2}. ` + e.innerHTML.replace(/^[0-9\.]+ /, '');

                            cnt3 = 0;
                            cnt4 = 0;
                            break;
                        case "H3":
                            cnt3++;
                            e.innerHTML = `${cnt}.${cnt2}.${cnt3}. ` + e.innerHTML.replace(/^[0-9\.]+ /, '');

                            cnt4 = 0;
                            isDataTable = true;
                            break;
                        case "H4":
                            cnt4++;
                            e.innerHTML = `${cnt}.${cnt2}.${cnt3}.${cnt4}. ` + e.innerHTML.replace(/^[0-9\.]+ /, '');
                            isDataTable = true;
                            break;
                        default:
                            break;
                    }
                    e.id = `${cnt}_${cnt2}_${cnt3}_${cnt4}`;
                    contentList.content.push({ innerHTML: e, isDataTable: isDataTable, id: `${cnt}_${cnt2}_${cnt3}_${cnt4}` });
                }
            });
            
            const ref_list = [...contentList.table, ...contentList.image];
            document.querySelectorAll("a.tblref").forEach((e) => {
                try {
                    const tr = e.dataset.tblref?.toLowerCase().replace(/^\[:(.*):\]$/,"$1").split("::");
                    let ref;
                    if(tr.length > 2) {
                        const qs = (tr[0]+tr[1]).toUpperCase();
                        const tbl = tr[2].toUpperCase();
                        ref = ref_list.filter(ft => ft.tbltp).find(fi => fi.tbltp === qs+tbl);
                    } else {
                        const tbl_name = tr[tr.length-1];
                        ref = ref_list.find(f => {
                            let ele = f.innerHTML?.innerText;
                            ele = ele.replace(/^(table|figure) [0-9]+\. /i,'').trim().toLowerCase();
                            return ele.startsWith(tbl_name.toLowerCase());
                        });
                    }

                    try {
                        if(ref) {
                            e.innerHTML = "["+ref.innerHTML.innerText+"]";
                            e.href = "#"+ref.id;
                            
                            e.classList.remove("tblref");
                        } else {
                            e.innerHTML = "[#REFERROR!]"
                        }
                    } catch(e) {
                        
                    } finally {
                        // e.classList.remove("tblref");
                    }
                } catch(e) { console.error(e)}
            })            

            // Table 깨짐 수정
            document.querySelectorAll("figure").forEach((e) => {
                try {
                    if (e.style?.width.includes("%")) {
                        const widthPercent = parseFloat(e.style.width.replaceAll(/%$/g, ""));
                        if (widthPercent > 100) {
                            e.style.width = "100%";
                        }
                    }
                    if (e.style?.height) {
                        e.style.height = null;
                    }
                    e.outerHTML = `<div style="width: 100%; display: block">${e.outerHTML}</div>`;
                } catch (e) { }
            });

            SetList(contentList);
        }
        return () => { clearTimeout(tmout) };
    }, [Data]);

    const ListRender = useMemo(() => {
        const { content, table, image } = List;
        if (table.length > 0) {
            return (
                <>
                    <div className="pdf-page ck-content contentlist">
                        <p
                            style={{
                                fontSize: "1.15rem",
                                fontWeight: "bold",
                                margin: "7pt 0",
                            }}
                        >
                            List of Contents
                        </p>
                        {content?.map((e, i) => {
                            const { innerHTML, id, isDataTable } = e;
                            if (!isDataTable) {

                                const margin = (innerHTML.innerHTML?.match(/^(\d+.)+ /)?.[0]?.split(".")?.length ?? 2) - 2;

                                return (
                                    <p
                                        key={"docPreviewList" + i}
                                        style={{
                                            marginLeft: (margin < 1 ? 0 : margin * 1) + "rem",
                                        }}
                                        href={"#" + id}
                                        dangerouslySetInnerHTML={{ __html: innerHTML.innerHTML }}
                                    // href={"#"+id}
                                    ></p>
                                );
                            } else return null;
                        })}
                    </div>
                    {table.length > 0 && (
                        <div className="pdf-page ck-content contentlist">
                            <p
                                style={{
                                    fontSize: "1.15rem",
                                    // textAlign: "center",
                                    fontWeight: "bold",
                                    margin: "7pt 0",
                                }}
                            >
                                List of Tables
                            </p>
                            {table?.map((e, i) => {
                                const { innerHTML, id, isDataTable } = e;
                                if (!isDataTable) {
                                    return <p key={"docPreviewListTbl" + i} href={"#" + id} dangerouslySetInnerHTML={{ __html: innerHTML.innerHTML }}></p>;
                                } else return null;
                            })}
                        </div>
                    )}
                    {image.length > 0 && (
                        <div className="pdf-page ck-content contentlist">
                            <p
                                style={{
                                    fontSize: "1.15rem",
                                    // textAlign: "center",
                                    fontWeight: "bold",
                                    margin: "7pt 0",
                                }}
                            >
                                List of Figures
                            </p>
                            {image?.map((e, i) => {
                                const { innerHTML, id, isDataTable } = e;
                                if (!isDataTable) {
                                    return <p key={"docPreviewListImg" + i} href={"#" + id} dangerouslySetInnerHTML={{ __html: innerHTML.innerHTML }}></p>;
                                } else return null;
                            })}
                        </div>
                    )}
                </>
            );
        } else return null;
    }, [Data, List]);

    const savePDFTest = () => {
        const head = document.head;

        const hasStyle = head.querySelector("style[media=print]");
        if (hasStyle) hasStyle.remove();

        const orientation = Orientation ? "landscape" : "portrait";
        const css = `@page { size: A4 ${orientation}; }`;
        const style = document.createElement("style");
        style.type = "text/css";
        style.media = "print";
        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);

        window.print();
        window.close();
    };

    const savePDFHandler = () => {
        savePDF();
    };

    const savePDF = async () => {
        const pdf = document.getElementById("pdf-container").querySelectorAll(".pdf-page");
        const pdfs = [];
        /*
            이전 코드
            let margin = document.getElementById("pagemargin")?.value || "15";
            try {
                margin = parseFloat(margin.replaceAll(/[^\d.]+/g,''));
            } catch(e) {
                document.getElementById("pagemargin").value = "15";
                margin = "15";
            }
        */

        const margin = 15;
;

        SetModalShow({ state: "PDF Generating", totalCnt: pdf.length, processCnt: 1 });
        for (let p of pdf) {
            const isDataTable = p.classList.contains("data-tables");
            let html = p.outerHTML;

            const response = await axios.post(process.env.REACT_APP_API + "/pcsPdf/pdfGenerate", {
                html:html,
                watermark: Data.revInfo.tempYn === 'Y' ? 'ON' : null,
                margin: margin + "mm",
                size: "A4 " + (isDataTable ? "landscape" : "portrait"),
            });
            if (response?.data) {
                pdfs.push(response.data);
                SetModalShow((OLD) => ({ ...OLD, processCnt: OLD.processCnt + 1 }));
            } else {
                throw new Error("Generate PDF got some Error");
            }
        }


        SetModalShow({ state: "PDF Merging" });
        const fileNames = Data?.desc?.[0];
        // const fileName = fileNames.projectNm + "_" + fileNames.processCd + "_" + fileNames.revision + ".pdf";
        const fileName = Data.revInfo.projectNm + "_" + Data.revInfo.processCd + "_" + Data.revInfo.revision + ".pdf";

        const { projectNm, processCd, revision, tempYn } = Data.revInfo;
        const date = new Date();
        const y = date.getFullYear(),
            m = LPAD(date.getMonth()+1, 2, 0),
            d = date.getDate(),
            t = date.toLocaleTimeString('en-US', { hour12: false, minute: "2-digit", second: "2-digit", hour: "2-digit" });
        const watermark = `${d}/${m}/${y} ${t} / ${userSelector.userNm} / ${projectNm} / ${processCd} / v${revision}.${tempYn === 'Y' ? 1 : 0}`
        await DownloadFile({
            api: "/pcsPdf/pdfMerge",
            body: {
                projectNm: Data.revInfo.projectNm,
                processCd: Data.revInfo.processCd,
                revision: Data.revInfo.revision,
                tempYn: Data.revInfo.tempYn,
                fileList: pdfs,
                fileName: fileName,
                watermark: Data.revInfo.tempYn === 'N' ? watermark : null,
            },
            name: fileName,
        });

        SetModalShow(null);
        if (props.func) props.func();
        else window.close();
    };



    const watermark = useMemo(() => {
        if (!Data) return;

        if (Data.revInfo.tempYn === 'N') {
            if (Data) {

                const { projectNm, processCd, revision, tempYn } = Data.revInfo;
                const date = new Date();
                const y = date.getFullYear(),
                    m = LPAD(date.getMonth(), 2, 0),
                    d = date.getDate(),
                    t = date.toLocaleTimeString('en-US', { hour12: false, minute: "2-digit", second: "2-digit", hour: "2-digit" });

                return <div id={"watermark"} className={"release"}>
                    <p>{`${d}/${m}/${y} ${t}`} / {userSelector.userNm} / {projectNm} / {processCd} / v{revision}.{tempYn === 'Y' ? 1 : 0}</p>
                </div>
            }
        } else {
            return <div id={"watermark"} className={"temporary"}>

            </div>
        }

    }, [Data])



    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="print-no">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "40px",
                            position: "relative",
                            zIndex: 999
                        }}
                    >
                        {/* <div style={{
                            display: "flex",
                        }}>
                            <span>margin: </span>
                            <input type="text" id="pagemargin" style={{width: "50px", textAlign: "right"}} defaultValue={"15"} />
                            <span>mm</span>
                        </div> */}
                        <div
                            style={{

                                gap: "10px",
                                alignItems: "center",
                            }}
                        >
                            {/* <div>
                                <FontAwesomeIcon style={{ fontSize: "1.5em" }} icon={faFile} />
                            </div>
                            <div
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    SetOrientation(!Orientation);
                                }}
                            >
                                <FontAwesomeIcon style={{ fontSize: "2em" }} icon={Orientation ? faToggleOn : faToggleOff} />
                            </div>
                            <div>
                                <FontAwesomeIcon style={{ fontSize: "1.5em", transform: "rotate(-90deg)" }} icon={faFile} />
                            </div> */}
                            {/* <div style={{zIndex: 999}}>
                                watermark is {isTemp ? "temp" : "release"}<br></br>
                                <button className={"bpl-btn success"} onClick={() => {setIsTemp(!isTemp)}}>Change</button>
                            </div> */}
                        </div>
                        {/* <div style={{zIndex: 999}}>
                            <button className="bpl-btn main" onClick={savePDFHandler}>
                                PDF Download
                            </button>
                        </div> */}
                    </div>
                </div>
                <div id="pdf-container">
                    {ListRender}

                    {MainRender}
                    {/* 
                        Revision 정보 일시 숨김
                        {Data && (
                        <div
                            className="pdf-page ck-content"
                            style={{
                                width: "60%",
                                marginLeft: "auto",
                                marginRight: "auto",
                            }}
                        >
                            <table
                                className="bpl-table-default gray-tone"
                                style={{ width: "100%" }}
                            >
                                <thead>
                                    <tr>
                                        <th>Project</th>
                                        <th>MBR No.</th>
                                        <th>Process</th>
                                        <th>Unit Op.</th>
                                        <th>Version</th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">{RevInfoRender}</tbody>
                            </table>
                        </div>
                    )} */}
                    {watermark}
                </div>
            </div>
            {ModalShow && (
                <ModalPortal>
                    <div className={"loadPop"}>
                        <div className={"modalContainer"}>
                            <p>{ModalShow.state}</p>
                            {ModalShow.totalCnt && (
                                <p>
                                    {ModalShow.processCnt}/{ModalShow.totalCnt}
                                </p>
                            )}
                        </div>
                    </div>
                </ModalPortal>
            )}

        </>
    );
};

export default Preview;
